export default function initAccordeons () {
	const exception = document.querySelector('._bond');
	if (exception) return;

	const bonds = document.querySelectorAll('.issues-bond');
	if (!bonds.length) return;

	bonds.forEach(bond => {
		if (bond.classList.contains('disable')) return;

		bond.addEventListener('click', function(e) {
			const bondHeader = this.querySelector('.issues-bond__header');
			const isToggler = e.target === this || e.target === bondHeader || bondHeader.contains(e.target);

			if (isToggler) {
				if (!this.classList.contains('issues-bond_opened')) {
					setTimeout(() => {
						this.classList.add('issues-bond_opened');
					}, 0);
				}

				bonds.forEach(el => {
					el.classList.remove('issues-bond_opened');
				});
			}
		})
	})
}
